import { render, staticRenderFns } from "./teacherGroup.vue?vue&type=template&id=22dbb2fe&scoped=true&"
import script from "./teacherGroup.vue?vue&type=script&lang=js&"
export * from "./teacherGroup.vue?vue&type=script&lang=js&"
import style0 from "./teacherGroup.vue?vue&type=style&index=0&id=22dbb2fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dbb2fe",
  null
  
)

export default component.exports